<template>
  <AuthTemplate>
    <h1>Создание пароля</h1>
    <div>
      <div style="margin-bottom: 20px">
        <custom-input type="password" placeholder="Пароль" v-model="form.password" @change="() => errors.password = null"/>
        <error-text :text="errors.password"/>
      </div>
      <div style="margin-bottom: 20px">
        <custom-input type="password" placeholder="Подтвердите пароль" v-model="form.password_confirmation" @change="() => errors.password_confirmation = null"/>
        <error-text :text="errors.password_confirmation"/>
      </div>
      <button-component mb="10px" variant="filled" type="submit" @click="confirm()">Подтвердить номер</button-component>
    </div>
  </AuthTemplate>
</template>

<script>
import ButtonComponent from '../../../components/ui/buttons/button-component'
import CustomInput from '../../../components/ui/inputs/custom-input'
import AuthTemplate from '../../../templates/AuthTemplate'
import ErrorText from "@/components/ui/text/error-text";
import {mapMutations, mapGetters} from 'vuex'

export default {
  name: 'Register_Password',
  components: {ErrorText, ButtonComponent, CustomInput, AuthTemplate},
  data() {
    return {
      form: {},
      errors: {},
    }
  },
  methods: {
    ...mapMutations(['openModal', 'clearRegisterData', 'signIn']),
    ...mapGetters(['getRegisterData']),
    confirm() {
      this.$api.auth.register.password(this.getRegisterData().id, this.form).then(({data}) => {
        this.signIn(data);
        this.closeModals();
        this.clearRegisterData();
        this.$toast.success('Регистрация успешно пройдена!');
      }).catch(({response}) => {
        this.errors = response.data.errors;
        this.$toast.error('Проверьте указанные данные!');
      });
    }
  }
}
</script>

<style scoped>

</style>